import { Environment } from 'enums/environment'

const env = process.env.REACT_APP_ENV
const isDevelopment = env === Environment.Development
const isStaging = env === Environment.Staging
const isProduction = env === Environment.Production

export { isDevelopment, isStaging, isProduction }
